module.exports = __webpack_public_path__ + "img/money-bill-simple-wave.d66897d8.svg";